module.exports = __webpack_public_path__ + "static/media/4.4b64615e.png";